import "core-js/modules/es.array.map.js";
/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import { _ApplicationList, _Body, _Button, _ButtonContainer, _Close, _Container, _Header, _RequirementTitle, _Title } from "./style";
import LoadingOverlay from "../../../../components/core/ui/LoadingOverlay";
import CsvDownload from "../../../../components/CsvDownload";
var CSV_COLUMNS = [{
  name: 'Application ID',
  selector: 'applicationID'
}, {
  name: 'School Name',
  selector: 'schoolName'
}, {
  name: 'Program Name',
  selector: 'programName'
}];
var LinkedApplicationsListModal = function LinkedApplicationsListModal(_ref) {
  var onViewLinkedApplications = _ref.onViewLinkedApplications,
    requirementTemplateID = _ref.requirementTemplateID,
    internalTitle = _ref.internalTitle,
    applicationSchoolAndPrograms = _ref.applicationSchoolAndPrograms,
    request = _ref.request;
  return /*#__PURE__*/React.createElement(_Container, null, request.isLoading && /*#__PURE__*/React.createElement(LoadingOverlay, null), /*#__PURE__*/React.createElement(_Header, null, /*#__PURE__*/React.createElement(_Title, null, "List of Applications"), /*#__PURE__*/React.createElement(_Close, {
    onClick: onViewLinkedApplications
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "times"
  }))), /*#__PURE__*/React.createElement(_Body, null, /*#__PURE__*/React.createElement(_RequirementTitle, null, requirementTemplateID && "".concat(requirementTemplateID, ": "), internalTitle && "".concat(internalTitle, " "), " is charged by the following", applicationSchoolAndPrograms && " ".concat(applicationSchoolAndPrograms.length, " "), applicationSchoolAndPrograms.length > 1 ? 'applications' : 'application', ":"), applicationSchoolAndPrograms.map(function (_ref2) {
    var applicationID = _ref2.applicationID,
      schoolName = _ref2.schoolName,
      programName = _ref2.programName;
    return /*#__PURE__*/React.createElement(_ApplicationList, {
      key: "application-".concat(applicationID)
    }, /*#__PURE__*/React.createElement("a", {
      href: "/applications/".concat(applicationID),
      target: "_blank",
      rel: "noopener noreferrer"
    }, applicationID, ": ", schoolName, " - ", programName));
  }), /*#__PURE__*/React.createElement(_ButtonContainer, null, /*#__PURE__*/React.createElement(CsvDownload, {
    columns: CSV_COLUMNS,
    data: applicationSchoolAndPrograms
  }, /*#__PURE__*/React.createElement(_Button, {
    primary: true
  }, "Download")))));
};
export default LinkedApplicationsListModal;